<!--P110、P112-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy">品牌管理</div>
    </div>
    <!--表格-->
    <div class="cs_margin_top_sm div_search_result cs_padding_top_lg">
      <div class="div_operation_table">
        <button @click="btnAdd" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                type="button">添加
        </button>
      </div>
      <div class="cs_margin_top div_table">
        <table class="cs_table cs_thead_fixed cs_td_divider_none" width="100%">
          <thead>
          <tr>
            <th width="40px">序号</th>
            <th width="560px">品牌名称</th>
            <th width="100%">配送价系数</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in orderList">
            <td width="40px">{{index+1}}</td>
            <td width="560px"><a @click.stop="$router.push({name:'BrandDetail', query: {id:item.id,name:item.brandName,rate:item.deliveryRatio}})">{{item.brandName}}</a></td>
            <td width="100%">{{item.deliveryRatio}}</td>
          </tr>
          <template v-if="PAGE_SIZE>orderList.length">
            <tr v-for="(item,index) in (PAGE_SIZE-orderList.length)">
              <td width="40px"></td>
              <td width="560px"></td>
              <td width="100%"></td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="div_bottom"></div>

    <!--添加弹窗，默认隐藏-->
    <div v-if="isDialogAddShow" class="ui_div_dialog">
      <div class="ui_dialog_container" style="width:424px;height:316px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">添加品牌</div>
        </div>
        <div class="cs_margin_top_lg div_search">
          <div class="cs_title_primary cs_text_default type_info_search ui_margin_left_18">品牌</div>
          <input v-model="nameDialog" @input="nameDialogInput" class="cs_input cs_radius_lg edtxt_info_search width_246 ui_margin_left_58" placeholder="请输入">
        </div>
        <div class="div_search" style="margin-top: 12px;">
          <div class="cs_title_primary cs_text_default type_info_search ui_margin_left_18">配送价系数</div>
          <input v-model="coefficientDialog" @input="nameDialogInput"  @keyup="inputLimitPositiveFloat($event)" @blur="coefficientDialog=formatPositiveFloat($event)" class="cs_input cs_radius_lg edtxt_info_search width_246" placeholder="请输入">
        </div>
        <div class="cs_margin_top_sm cs_text_sm txt_hint_dialog">{{hintDialog}}</div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialog">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmDialog">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "BrandManage",
    components: {},
    data: function () {
      return {
        orderList: [],
        isDialogAddShow : false,
        nameDialog : "",
        coefficientDialog:"",
        hintDialog : "",
        PAGE_SIZE: 10
      }
    },
    created: function () {
      this.showList();
    },
    mounted: function() {
    },
    methods: {
      showList() {
        this.orderList =[];
        this.$ajax.brand.list.bind(this)((data) => {
          this.orderList = data.data;
        }, (data) => {
        }, true)
      },
      btnAdd(){
        this.isDialogAddShow = true;
      },
      btnConfirmDialog(){
        if (this.isEmpty(this.nameDialog)) {
          this.hintDialog = "请输入品牌";
          return
        }
        if (this.isEmpty(this.coefficientDialog)) {
          this.hintDialog = "请输入配送价系数";
          return
        }
        this.$ajax.brand.add.bind(this)(this.nameDialog,this.coefficientDialog, (data) => {
          this.$toast("添加成功");
          this.showList();
          this.closeDialog();
        }, (data) => {
        }, true,this.showErrorMsg)
      },
      closeDialog() {
        this.isDialogAddShow = false;
        this.nameDialog = "";
        this.coefficientDialog = "";
        this.hintDialog = "";
      },
      nameDialogInput(){
        this.hintDialog = "";
      },
      //错误提示
      showErrorMsg: function (msg) {
        this.hintDialog = msg;
      },
    },
  }
</script>

<style scoped>
  .cs_table tbody {
    max-height: 574px;
  }
  .width_246{width: 246px;}
  .txt_hint_dialog{
    position: relative;
    width: 100%;
    height: 20px;
    line-height: 20px;
    color: #FFB54C;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/page/brand/BrandManage.vue